var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46436 11.1063C8.46436 10.4994 8.67678 9.99866 9.10161 9.60418C9.52643 9.20969 10.0787 9.01245 10.7585 9.01245C11.4261 9.01245 11.9662 9.20665 12.3789 9.59508C12.8037 9.99564 13.0161 10.5176 13.0161 11.1609C13.0161 11.7435 12.8098 12.229 12.3971 12.6175C11.9723 13.018 11.4139 13.2183 10.722 13.2183H10.7038C10.0362 13.2183 9.4961 13.018 9.0834 12.6175C8.6707 12.2169 8.46436 11.7132 8.46436 11.1063ZM8.70105 27.0376V14.8752H12.743V27.0376H8.70105ZM14.9825 27.0376H19.0245V20.2463C19.0245 19.8214 19.0731 19.4937 19.1702 19.2631C19.3401 18.8504 19.598 18.5014 19.944 18.2162C20.2899 17.9309 20.7238 17.7883 21.2458 17.7883C22.6053 17.7883 23.285 18.7047 23.285 20.5376V27.0376H27.327V20.0642C27.327 18.2678 26.9022 16.9053 26.0525 15.9767C25.2028 15.0481 24.0801 14.5838 22.6842 14.5838C21.1183 14.5838 19.8985 15.2575 19.0245 16.6048V16.6413H19.0063L19.0245 16.6048V14.8752H14.9825C15.0068 15.2636 15.0189 16.4713 15.0189 18.4984C15.0189 20.5254 15.0068 23.3718 14.9825 27.0376Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2273,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8626,
    height: 18.0251,
    fill: "white",
    transform: "translate(8.46436 9.01245)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8341a7e1d427214877b1380a28745c61.svg";
export { ForwardRef as ReactComponent };